import * as React from 'react';

const SupportIcon = () => (
  <svg
    width="25"
    height="24"
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2.8382 17.25V15.1058C2.8382 9.71719 7.1651 5.26871 12.5537 5.25006C13.837 5.24552 15.1085 5.49436 16.2954 5.98231C17.4824 6.47025 18.5613 7.18771 19.4703 8.09353C20.3793 8.99934 21.1006 10.0757 21.5927 11.2609C22.0849 12.446 22.3382 13.7167 22.3382 15V17.25C22.3382 17.4489 22.2592 17.6397 22.1185 17.7803C21.9779 17.921 21.7871 18 21.5882 18H3.5882C3.38928 18 3.19852 17.921 3.05787 17.7803C2.91721 17.6397 2.8382 17.4489 2.8382 17.25Z"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.5882 5.25V8.25"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M3.17072 12.4766L6.06849 13.253"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.006 12.4766L19.1082 13.253"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.2862 18.0002L16.6973 9.64502"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SupportIcon;
